import React from "react";
import "./bootstrap.min.css";
import "./Login.css";
import { auth, provider } from "./firebase";
import { actionTypes } from "./reducer";
import { useStateValue } from "./StateProvider";

function Login() {
  const [state, dispatch] = useStateValue();

  const signIn = () => {
    auth
      .signInWithPopup(provider)
      .then((result) => {
        dispatch({
          type: actionTypes.SET_USER,
          user: result.user
        });
      })
      .catch((error) => alert(error.message));
  };
  return (
    <div className="login">
      <div className="login__logo">
        <img
          src="https://i.imgur.com/IiOae7z.png"
          className="elementToAnimatelogo"
        />
      </div>
      <button
        type="submit"
        className="btn btn-outline-primary btn-lg btn-block"
        onClick={signIn}
        variant="outlined">
        Sign In to <strong>Sad Napoleon</strong>
      </button>
    </div>
  );
}

export default Login;
